import { fetchCanonicalAttachmentBlob } from "./canonicalMessagingApi";

const entries = new Map();
let sessionToken;
const MAX_BYTES = 32 * 1024 * 1024;
export function clearAttachmentPreviewCache() { entries.clear(); sessionToken = undefined; }
export function evictAttachmentPreviews(ids) { ids.forEach(id => entries.delete(id)); }
export function retryableAttachmentError(error) {
  const status = error.status || error.response?.status;
  if ([403, 404].includes(status)) return false;
  return error.retryable === true || (status === 409 && error.code === "MESSAGING_ATTACHMENT_HYDRATION_REQUIRED")
    || [429, 502, 503, 504].includes(status) || ["ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK"].includes(error.code)
    || /timeout|timed out|network error/i.test(error.message || "");
}
export function loadAttachmentPreview(id) {
  const token = localStorage.getItem("accessToken");
  if (token !== sessionToken) { entries.clear(); sessionToken = token; }
  if (entries.has(id)) return entries.get(id).promise;
  const entry = {};
  entry.promise = (async () => {
    for (let attempt = 0; ; attempt++) {
      try { return await fetchCanonicalAttachmentBlob(id); }
      catch (error) {
        if (attempt >= 3 || !retryableAttachmentError(error)) throw error;
        await new Promise(resolve => setTimeout(resolve, 1500 * (attempt + 1)));
      }
    }
  })().then(blob => {
    if (entries.get(id) === entry) {
      entry.bytes = blob.size;
      let bytes = [...entries.values()].reduce((sum, value) => sum + (value.bytes || 0), 0);
      for (const [key, value] of entries) {
        if (bytes <= MAX_BYTES) break;
        if (value.bytes != null) { entries.delete(key); bytes -= value.bytes; }
      }
    }
    return blob;
  }, error => { if (entries.get(id) === entry) entries.delete(id); throw error; });
  entries.set(id, entry);
  return entry.promise;
}
